import * as bootstrap from "sard_core/vendor/assets/bootstrap/javascripts/bootstrap"

const initPopovers = (container = document) => {
  // add content if any html popovers found
  const htmlPopoverTriggerList = container.querySelectorAll('.html-popover')
  htmlPopoverTriggerList.forEach(htmlPopoverTriggerEl => {
    const contentElement = htmlPopoverTriggerEl.nextElementSibling
    if (contentElement?.classList.contains('html-popover-content')) {
      htmlPopoverTriggerEl.setAttribute('data-bs-content', contentElement.innerHTML)
    }
  })

  const popoverTriggerList = [
    ...htmlPopoverTriggerList,
    ...container.querySelectorAll('[data-bs-toggle="popover"]')
  ]

  const popoverList = popoverTriggerList.map(popoverTriggerEl => {
    // Skip if already initialized
    if (bootstrap.Popover.getInstance(popoverTriggerEl)) {
      return null
    }

    let config = { html: true, sanitize: false }
    if (popoverTriggerEl.classList?.contains('html-popover')) {
      config.sanitize = false
      config.container = popoverTriggerEl.parentElement
    }
    return new bootstrap.Popover(popoverTriggerEl, config)
  }).filter(Boolean)

  return popoverList
}

let allPopovers = []

const disposePopovers = () => {
  allPopovers.forEach(popover => {
    if (popover?._element) {
      popover.dispose()
    }
  })
  allPopovers = []
}

const setupPopovers = () => {
  allPopovers = initPopovers()
}

// Initialise on page load. turbo:load fires once on the initial load even when
// Turbo Drive is disabled (as it is in the host apps), and again on every Turbo
// Drive visit if it is ever enabled.
document.addEventListener("turbo:load", setupPopovers)

// Dispose before Turbo caches the page (Turbo Drive) so the cached snapshot is
// clean, and on unload so instances/tips don't leak.
document.addEventListener("turbo:before-cache", disposePopovers)
window.addEventListener("beforeunload", disposePopovers)

// Restore popovers after a back/forward cache (bfcache) restore.
//
// With Turbo Drive disabled, navigating away is a full page load, so the outgoing
// page can be frozen into the browser's bfcache. On a persisted pageshow the DOM
// is restored from that frozen snapshot WITHOUT re-running scripts — turbo:load
// does not fire — but disposePopovers has already run on beforeunload, leaving the
// triggers with no popover instance. Re-initialise them here so hovering/focusing
// the info icons works again without a hard refresh. initPopovers is idempotent:
// any instance that survived the freeze is skipped via getInstance.
window.addEventListener("pageshow", (event) => {
  if (event.persisted) setupPopovers()
})

// Reinitialize popovers when Turbo Frames load new content
document.addEventListener("turbo:frame-load", (event) => {
  const newPopovers = initPopovers(event.target)
  allPopovers = [...allPopovers, ...newPopovers]
})
